<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="modal-write">
        <div class="modal-write__form">
          <div class="modal-write__title">Напишите нам</div>
          <div class="modal-write__info">
            Мы обработаем Ваш запрос и свяжемся с Вами
          </div>
          <div class="modal-write__phone">
            <NuxtLink to="tel:+79054758409">+7 (900) 278-68-76</NuxtLink>
            <IconDef name="whatsapp"></IconDef>
            <IconDef name="tele"></IconDef>
          </div>
          <div class="modal-write__mail">
            <NuxtLink to="mailto:info@blvka.ru">info@sharun.store</NuxtLink>
          </div>
          <form action="">
            <div class="modal-write__inputs-row">
              <Input
                placeholder="Ваше имя"
                name="login"
                type="text"
                class="input input-full"
                v-model="name"
              />
              <Input
                placeholder="Ваш телефон"
                name="phone"
                type="text"
                class="input input-full"
                v-model="phone"
              />
            </div>
            <div class="modal-write__input-box">
              <Textarea
                placeholder="Комментарий"
                name="comment"
                type="text"
                class="input input-full"
                v-model="comment"
              />
            </div>
            <Button
              title="Записаться"
              class="full-dark-btn"
              type="button"
              @click.prevent="send"
            >
            </Button>
            <Checkbox
              label="Я соглашаюсь с <a href='#'>политикой конфиденциальности</a>"
              :isCheck="true"
              name="agreement_politic"
            />
            <LoginHint v-if="!(productId && productType === 2)" />
          </form>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import LoginHint from "~/components/UI/LoginHint.vue";
import IconDef from "~/components/UI/IconDef.vue";
import Checkbox from "~/components/UI/btn/Checkbox.vue";
import Button from "~/components/UI/btn/Button.vue";
import Input from "~/components/UI/inputs/Input.vue";
import Textarea from "~/components/UI/inputs/Textarea.vue";
import modal from "~/components/UI/Modal.vue";
import api from "~/api/api.js";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleVisible: {
    type: Boolean,
    default: true,
  },
  productId: {
    type: Number,
    default: null,
  },
  productType: {
    type: Number,
    default: null,
  },
});
const emits = defineEmits(["close"]);

const name = ref("");
const phone = ref("");
const comment = ref("");

async function send() {
  if (!name.value || !phone.value) {
    alert("Заполните имя и телефон");
    return;
  }

  const formData = new FormData();
  formData.append("name", name.value);
  formData.append("phone", phone.value);
  if (comment.value) formData.append("comment", comment.value);

  // productType 2 = предзаказ → orders/manage/preorder
  // productType 1 = заявка на услугу → service-orders/submit
  // иначе → legacy /request (общая форма без продукта)
  let endpoint = "/request";
  if (props.productId && props.productType === 2) {
    endpoint = "/orders/manage/preorder";
    formData.append("product_id", String(props.productId));
  } else if (props.productId && props.productType === 1) {
    endpoint = "/service-orders/submit";
    formData.append("product_id", String(props.productId));
  } else if (props.productId) {
    formData.append("productId", String(props.productId));
  }

  try {
    await api(endpoint, formData, "POST");
    alert("Заявка отправлена");
    name.value = "";
    phone.value = "";
    comment.value = "";
    emits("close");
  } catch {
    alert("Ошибка при отправке. Попробуйте ещё раз.");
  }
}
</script>
